import Skeleton from "@mui/material/Skeleton";

export default function ImagePlaceHolder({ width = 120, height = 120 }: any) {
  return <Skeleton variant="rounded" width={width} height={height} />;
}
